export enum EApi {
    URL = "https://hejde.um.si/api",
    OPENSTREET_URL ="https://nominatim.openstreetmap.org/?addressdetails=1&format=json&accept-language=en&q=",
    GET = "GET",
    POST = "POST",
    DELETE = "DELETE",
    PUT = "PUT"
}